module.exports = __webpack_public_path__ + "img/index-bottom.ce79cee3.png";